import 'angular:locale/data:en';
import 'angular:locale/data:es';(globalThis.$localize ??= {}).locale = "___NG_LOCALE_INSERT___";
